import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // Create this file for header-specific styles
import chromeIcon from './chrome.svg'; // Adjust path as needed

function Header() {
    return (
        <header className="header">
            <div className="header-left">
                {/* <Link to="/">
          <img src={logo} alt="ChatGPT Toolbox Logo" className="logo" />
        </Link> */}
            </div>

            <nav className="header-nav">
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/Updates">Updates</Link>
                    </li>
                    <li>
                        <Link to="/pricing">Pricing</Link>
                    </li>
                </ul>
            </nav>

            <div className="header-right">
                <button onClick={() => window.open("https://chrome.google.com/webstore/category/extensions", "_blank")} className="extension-button">
                    <img src={chromeIcon} alt="Chrome" className="mr-2" style={{ width: '20px', height: '20px' }} />
                    Add To Chrome
                </button>

            </div>
        </header>
    );
}

export default Header;